<template>
  <div>
    <b-row>
      <div class="text-center">
        <h3 class="mt-4">{{ $t('pages.campaign.campaign_schedule.title') }}</h3>
        <p class="text-muted font-size-14  mb-5">
          {{ $t('pages.campaign.campaign_schedule.subtitle') }}
        </p>
      </div>
      <b-col sm="12">
        <campaign-alert :type="selectedTemplateType"/>
      </b-col>
      <b-col sm="12">
        <div class="mb-3">
          <label class="control-label">{{ $t('pages.campaign.campaign_schedule.after_this') }}
            <hint>{{ $t('pages.campaign.campaign_schedule.infos.after_this_info') }}</hint>
          </label>
          <b-form-select
              class="form-select"
              v-model="selectedOrderStatus">
            <b-form-select-option
                v-for="(option, index) in orderStatusOptions"
                :key="index"
                :disabled="option.disabled"
                :value="option.value">
              {{ option.name }}
            </b-form-select-option>
          </b-form-select>
        </div>
      </b-col>
      <b-col sm="12">
        <div class="mb-3">
          <label class="control-label">{{ $t('pages.campaign.campaign_schedule.after_day') }}
            <hint>{{ $t('pages.campaign.campaign_schedule.infos.after_day_info') }}</hint>
          </label>
          <div class="mt-2 mb-2">
            <quantity-input
                v-model="selectedDay"
                :min="min"
                :max="30"
            ></quantity-input>
          </div>
        </div>
      </b-col>
      <b-col sm="12">
        <div class="mb-3">
          <label class="control-label">{{ $t('pages.campaign.campaign_schedule.time') }}
            <hint>{{ $t('pages.campaign.campaign_schedule.infos.time_info') }}</hint>
          </label>
          <date-picker
              :clearable="false"
              v-model="selectedTime"
              :minute-step="15"
              format="HH:mm"
              value-type="format"
              type="time"
              placeholder="HH:mm"
          ></date-picker>
        </div>
      </b-col>
      <b-col sm="12" class="mt-4">
        <b-alert show variant="success">
          <div v-html="$t('pages.campaign.campaign_schedule.alert_message', {
              day: selectedDay,
              order_status: orderStatusOptions.find(x => x.value === selectedOrderStatus).name,
              time: selectedTime
            })"></div>
        </b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import QuantityInput from "../../../../../components/widgets/QuantityInput";
import {campaignComputed} from "@/state/helpers";
import CampaignAlert from "../CampaignAlert";
import DatePicker from "vue2-datepicker";

export default {
  name: "CampaignSchedule",
  components: {CampaignAlert, QuantityInput, DatePicker},
  data() {
    return {
      orderStatusOptions: [
        {
          name: this.$t('pages.campaign.campaign_schedule.order_status.order_date'),
          value: "order_date",
          disabled: false
        },
        {
          name: this.$t('pages.campaign.campaign_schedule.order_status.delivery_date'),
          value: "delivery_date",
          disabled: false
        },
        {
          name: this.$t('pages.campaign.campaign_schedule.order_status.shipping_date'),
          value: "shipping_date",
          disabled: false
        }
      ],
      selectedOrderStatus: 'order_date',
      selectedDay: 2,
      selectedTime: "18:00",
      min: 1
    }
  },
  computed: {
    ...campaignComputed
  },
  watch: {
    selectedTemplateType(newVal) {
      const type = this.templateTypeOptions[newVal]
      if (type) {
        this.selectedDay = type.validations?.minDay ?? this.selectedDay
        this.min = type.validations?.minDay ?? this.min
        let flag = false
        this.orderStatusOptions.forEach(item => {
          item.disabled = !type.validations[item.value];
          if (!item.disabled && !flag) {
            this.selectedOrderStatus = item.value
            flag = true
          }
        })
      } else {
        this.min = 1
        this.selectedDay = 2
        this.selectedOrderStatus = 'order_date'
        this.orderStatusOptions.map(item => item.disabled = false)
      }
    }
  },
  methods: {
    validate() {
      const data = {
        afterThis: this.selectedOrderStatus,
        time: this.selectedTime,
        afterDay: this.selectedDay
      }
      this.$emit('on-validate', data, true)
      return true
    }
  }
}
</script>

<style scoped>

</style>